import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";

import {formatDuration} from "utils";
import {Route} from "v2/api/Records";

const RouteTargets = (props) => {
  const {route} = props;

  if (route.balance === 0 || !route.target) {
    return null;
  }

  const minDuration = route.target.totalMinutes && formatDuration(
    moment.duration(route.target.totalMinutes.lower, "minutes"), false
  );
  const maxDuration = route.target.totalMinutes && formatDuration(
    moment.duration(route.target.totalMinutes.upper, "minutes"), false
  );

  return (
    <div
      className="clearfix text-muted small erg-margin-top-5">
      <strong className="erg-block pull-left">
        Target
      </strong>
      <span className="erg-block pull-right">
        <i className="fa fa-clock-o" /> + <i className="fa fa-car" />
        <span className="erg-margin-left-5">
          {minDuration} - {maxDuration}
        </span>
      </span>
    </div>
  );
};

RouteTargets.defaultProps = {
  style: {},
};
RouteTargets.propTypes = {
  route: PropTypes.instanceOf(Route).isRequired,
};

export default RouteTargets;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteTargets.js
 **/